export class UserSetting {
  id: number;
  name: string;
  value: boolean | string | number;

  static fixedSetting(name: string, value: boolean | string | number) {
    const setting = new UserSetting();

    setting.name = name;
    setting.value = value;

    return setting;
  }
}
